module.exports = __webpack_public_path__ + "static/media/Ministry-of-Education.34eff1f2.png";